module.exports = __webpack_public_path__ + "img/icon_multiSign2.16d71ec4.svg";